import ProductCard from "../components/ProductCard/ProductCard";
import ProductFilter from "../components/ProductFilter/ProductFilter";
import { useState } from "react";
import "../Products.css";
import products from "../data/Products.json";

function Products({ wishlist, onAddToWishlist, onRemoveFromWishlist }) {
  const [category, setCategory] = useState("All");

  // استخراج الفئات
  const categories = [ ...new Set(products.map((p) => p.category))];

  // فلترة المنتجات حسب الفئة
  const filteredProducts =
    category === "All"
      ? products
      : products.filter((p) => p.category === category);

  return (
    <div className="products-page py-5">
      <div className="container">
        <h2 className="fw-bold text-center main-color mb-4">Our Products</h2>

        <ProductFilter
          categories={categories}
          selectedCategory={category}
          setCategory={setCategory}
        />

        <div className="row">
          {filteredProducts.map((product) => {
            const isFavorite = wishlist.some((item) => item.id === product.id);
            return (
              <ProductCard
                key={product.id}
                product={product}
                isFavorite={isFavorite}
                onToggleFavorite={() =>
                  isFavorite
                    ? onRemoveFromWishlist(product.id)
                    : onAddToWishlist(product)
                }
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default Products;
